import { TaskStatus } from '@shared/enums/task-status.enum';
import { ITaskStatus } from '@shared/interfaces/task-status.list.interface';

export const TaskStatusList: ITaskStatus[] = [
  {
    id: TaskStatus.CREATED,
    label: `Projects.TaskStatus.${TaskStatus.CREATED}`
  },
  {
    id: TaskStatus.COMPLETED,
    label: `Projects.TaskStatus.${TaskStatus.COMPLETED}`
  },
  {
    id: TaskStatus.CANCELLED,
    label: `Projects.TaskStatus.${TaskStatus.CANCELLED}`
  }
];
